import styled from 'styled-components';

// Main containers
export const ContentContainer = styled.div`
  display: flex;
  flex-grow: 1; 
  height: 100%; 
  overflow: hidden; 
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(25, 30, 45, 0.6) 0%, rgba(20, 25, 40, 0.8) 100%);
`;

export const ConversationViewContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: transparent;
  border-left: 1px solid rgba(100, 150, 200, 0.15);
  height: 100%;
  overflow: hidden;
  position: relative;
`;

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  padding-bottom: 100px;
  height: 100%;
  overflow-y: auto;
  background: transparent;
  color: rgba(200, 220, 255, 0.9);
  user-select: text;
  cursor: text;
`;

// Define a more subtle gradient for navigation buttons
export const OrangeGradient = `linear-gradient(135deg, rgba(50, 70, 100, 0.5) 0%, rgba(40, 60, 90, 0.6) 100%)`;
export const HoverOrangeGradient = `linear-gradient(135deg, rgba(60, 90, 130, 0.6) 0%, rgba(50, 80, 120, 0.7) 100%)`;

// Fixed layout CSS for strict rendering control
export const FixedLayoutCSS = `
* {
  text-rendering: geometricPrecision !important;
}
.message-item * {
  transform: none !important;
  transition: none !important;
  -webkit-transform: none !important;
  -webkit-transition: none !important;
  animation: none !important;
  -webkit-animation: none !important;
  user-select: none !important;
  -webkit-user-select: none !important;
  pointer-events: none !important;
  cursor: default !important;
  text-decoration: none !important;
}
/* Ensure buttons remain clickable */
button, button * {
  pointer-events: auto !important;
  cursor: pointer !important;
}
button:disabled, button:disabled * {
  cursor: not-allowed !important;
}
.message-content {
  position: static !important;
  word-break: break-word !important;
  white-space: pre-wrap !important;
}
.message-bubble {
  transform: none !important;
  -webkit-transform: none !important;
  backface-visibility: visible !important;
}
`;

// Message indicator styles
export const MessageIndicator = styled.div`
  position: absolute;
  left: -10px;
  width: 5px;
  height: 10px;
  background-color: orange;
  border-radius: 2px;
  opacity: 0.8;
`;

export const DateDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0 15px 0;
  
  &:before, &:after {
    content: '';
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(100, 150, 200, 0.2), transparent);
  }
  
  span {
    padding: 0 15px;
    font-size: 12px;
    color: rgba(180, 195, 220, 0.7);
    background: transparent;
    font-weight: 500;
  }
`;

export const HighlightStyle = styled.style`
  /* Apply global fixes */
  ${FixedLayoutCSS}
  
  .highlight-search {
    background-color: rgba(0, 108, 219, 0.5) !important;
    border-radius: 2px !important;
    padding: 0 2px !important;
    color: white !important;
    pointer-events: none !important;
    box-shadow: none !important;
    border: none !important;
    margin: 0 !important;
    text-decoration: none !important; 
    display: inline !important;
    position: static !important;
  }
  
  .active-highlight {
    background-color: rgba(0, 108, 219, 0.8) !important;
    border: 1px solid rgb(0, 108, 219) !important;
  }
  
  /* Disable user selection completely */
  .message-item * {
    user-select: none !important;
    -webkit-user-select: none !important;
    pointer-events: none !important;
  }
  
  /* Disable all hover effects */
  .message-item *:hover {
    transform: none !important;
    opacity: 1 !important;
    background: inherit !important;
  }
  
  /* Force stable content */
  .message-bubble {
    transform: none !important;
    will-change: auto !important;
    backface-visibility: visible !important;
  }
`;

export default {
  ContentContainer,
  ConversationViewContainer,
  MessagesContainer,
  DateDivider,
  OrangeGradient,
  HoverOrangeGradient,
  FixedLayoutCSS,
  MessageIndicator,
  HighlightStyle
}; 